// @ts-nocheck
import { useEffect, useState } from "react";
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import {
    myAxios,
    boolAndReducer,
    /* MyDate */
} from "src/components/common/functions";
//---------------------------------------------------------------------
export default function Inventory({
    closeIt
}){
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const [settingsData, setSettingsData] = useState({});
    const [yardsData, setYardsData] = useState({});
    const [fitleredWord, setFilteredWord] = useState("");
    const filteredList = Object.entries(yardsData).map(entry => 
        ({
            name: [entry[1].title],
            items: Object.entries(entry[1].inventory).filter(entry => 
            fitleredWord.toLowerCase().split(" ").map(f => JSON.stringify(
                Object.values([entry, settingsData[entry[0]]])
            ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)
        )})
    ).filter(yard => yard.items.length);
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res1 = await myAxios({ fileName: "fleet/readInventory.php" });
            if(!isMounted) return;
            setShowLoader(false);
            if(!res1) return;
            //---------------------------------------------------------------------
            setSettingsData(res1.data);
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res2 = await myAxios({ fileName: "fleet/readInventoryYards.php" });
            if(!isMounted) return;
            setShowLoader(false);
            if(!res2) return;
            //---------------------------------------------------------------------
            setYardsData(res2.data);
        }
        getData();
        return () => isMounted = false;
    }, [setShowLoader]);
    return (
        <Modal
            closeIt = {closeIt}
            title = {"Inventory"}
            width = {"60%"}
        >
            <div className = "d-flex my-3">
                <label children = "Search" htmlFor = "search"/>
                <input
                    id = "search"
                    className = "ms-2 form-control flex-grow-1"
                    value = {fitleredWord}
                    onChange = {e => setFilteredWord(e.currentTarget.value)}
                />
            </div>
            {filteredList.map((yard, entryIndex) => 
            <div key = {entryIndex} value = {entryIndex}>
                <h4>Yard {entryIndex + 1} {yard.name}</h4>
                <ul>
                    {yard.items
                    .map(([key, renderedValue], index) => 
                    <li className = "my-3 align-items-center" key = {index}>
                        <label
                            htmlFor = {key + " item"}
                            className = "inline"
                        >
                            Item {index + 1}
                        </label>
                        {settingsData[key]?.path?
                        <img
                            className = "ms-2 rounded"
                            src = {settingsData[key].path}
                            alt = ""
                            style = {{
                                width: 100, 
                                height: 100
                            }}
                        />:
                        <></>
                        }
                        <input
                            data-toggle = "tooltip"
                            title = {settingsData[key]?.note ?? ""}
                            id = {key + " item"}
                            className = {`ms-2 form-control inline flex-grow-1 ${settingsData[key]?.note?"text-info":""}`}
                            readOnly
                            value = {settingsData[key]?.title ?? ""}
                        />
                            <label
                                className = "ms-2 inline"
                                htmlFor = {key + " qty"}
                            >
                                Quantity
                            </label>
                        <input
                            required
                            type = "number"
                            min = {0} id = {key + " qty"}
                            className = "form-control ms-2"
                            style = {{width: "100px"}}
                            value = {renderedValue.qty}
                            readOnly
                        />
                        <label className = "ms-2 inline" htmlFor = {key + " yardItemNote"}>Note</label>
                        <input
                            id = {key + " yardItemNote"}
                            className = {"ms-2 inline form-control flex-grow-1"}
                            value = {renderedValue.yardItemNote}
                            readOnly
                        />
                        <span>
                        </span>
                    </li>)
                    }
                </ul>
            </div>)}
        </Modal>
    )
}